// extracted by mini-css-extract-plugin
export default {"topbtn":"Wttsep_topbtn__Juq-0","animShadow":"Wttsep_animShadow__rm1kh"};